import { Element as RustigElement } from 'rustig';

export class CustomElements {
  public static register(): void {
    RustigElement.addType('[data-accounting-display]', $element => new AccountingDisplay($element[0]));
  }
}

class AccountingDisplay {
  private element: HTMLElement;

  public get $userFacingElement(): JQuery { return $(this.element); }
  public get $valueElement(): JQuery { return $(this.element); }

  public constructor(element: HTMLElement) {
    if (!element)
      throw new Error('element cannot be null');

    this.element = element;
  }

  // using jquery to stay consistent with GenericElement
  public value(value?: any): any | void {
    if (value !== undefined) {
      $(this.element).data('rustig.value', null);
      return;
    }

    return $(this.element).data('rustig.value');
  }

  public text(text?: string): string | void {
    if (text === undefined)
      return this.element.textContent;

    this.element.removeAttribute('data-negative');
    if (!text)
      text = '0';

    let shouldShowSymbol = this.element.hasAttribute('data-show-symbol');
    let currency = this.toCurrency(text, shouldShowSymbol);

    let isNegative = currency.indexOf('-') !== -1;
    if (isNegative) {
      currency = '(' + currency.replace('-', '') + ')';
      this.element.setAttribute('data-negative', 'on');
    }

    this.element.textContent = currency;
  }

  private toCurrency(value: string, shouldShowSymbol: boolean) {
    value = value.replace(/[^-0-9.]/g, '');
    value = parseFloat(value)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&,'); // https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-dollars-currency-string-in-javascript
    if (shouldShowSymbol)
      value = '$' + value;
    return value;
  }

  public name(): string {
    return null;
  }
}